export default __webpack_public_path__ + "static/media/arrow-down.aeea32e3.svg";